import { NavLink } from 'react-router-dom';

/**
 * Navegación inferior fija estilo app móvil.
 *
 * @param {{ items: { to: string, label: string, icon: React.ReactNode, end?: boolean }[] }} props
 */
export default function BottomNav({ items }) {
  if (!items?.length) return null;

  return (
    <nav className="pulso-bottom-nav" aria-label="Navegación principal">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `pulso-bottom-nav__item${isActive ? ' is-active' : ''}`
          }
        >
          <span className="pulso-bottom-nav__icon" aria-hidden="true">{item.icon}</span>
          <span className="pulso-bottom-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
